import { render, staticRenderFns } from "./LawLedesList.vue?vue&type=template&id=152bae8c&"
import script from "./LawLedesList.vue?vue&type=script&lang=js&"
export * from "./LawLedesList.vue?vue&type=script&lang=js&"
import style0 from "./LawLedesList.vue?vue&type=style&index=0&id=152bae8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports